<template>
  <a
    href="#"
    :class="b({ expanded, iconPosition, backgroundColor })"
    @click.prevent="$emit('toggle', $event)"
  >
    <div :class="b('inner')">
      <div :class="b('title')">
        {{ title }}
      </div>
      <div :class="b('icon')">
        <e-icon-sprite icon="i-chevron-2--up" />
      </div>
    </div>
  </a>
</template>

<script>
  import eIconSprite from '@/elements/e-icon-sprite.vue';

  /**
   * Renders a toggle (header) element inside an expansion panel (collapse).
   */
  export default {
    name: 'c-expansion-panel-toggle',
    components: {
      eIconSprite,
    },

    // mixins: [ ],

    props: {
      /**
       * Sets state of the item.
       */
      expanded: {
        type: Boolean,
        default: false,
      },

      /**
       * Sets the title text.
       */
      title: {
        type: String,
        required: true,
      },

      /**
       * Sets the icon position.
       */
      iconPosition: {
        type: String,
        default: 'right',
        validator(value) {
          return ['right', 'left'].includes(value);
        },
      },

      /**
       * Container background color.
       */
      backgroundColor: {
        type: String,
        default: 'lightgray',
        validator(value) {
          return ['transparent', 'white', 'lightgray'].includes(value);
        },
      },
    },

    emits: ['toggle'],

    // data() {
    //   return {
    //   };
    // },

    // computed: { },
    // watch: {},

    // beforeCreate() {},
    // created() { },
    // beforeMount() {},
    // mounted() { },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() { },
    // unmounted() {},

    // methods: { },
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss-v2/component' as *;

  // Theme properties
  @include define-theme-properties-for(
    'default',
    'c-cms-expansion-panel-toggle',
    (
      'color': var(--color-primary--1),
      'border-color': var(--color-gray--100),
      'background-lightgray': var(--color-gray--50),
      'background-white': var(--color-white),
    )
  );

  .c-expansion-panel-toggle {
    #{--text-color}: color(--c-cms-expansion-panel-toggle-color);

    $this: &;
    $icon-spacing: 20px;

    @include font-label--big();

    display: block;
    padding: 14px 30px;
    border-bottom: 1px solid color(--c-cms-expansion-panel-toggle-border-color);
    cursor: pointer;
    color: var(--text-color);
    text-decoration: none;
    transition: border-bottom-color var(--duration--normal) linear;

    &:active,
    &:hover,
    &:focus {
      color: var(--text-color);
      text-decoration: none;
    }

    &--expanded {
      border-bottom-color: transparent;

      #{$this}__icon .e-icon-sprite {
        transform: rotate(0);
      }
    }

    &--icon-position-left #{$this}__icon {
      order: -1;
      margin-right: $icon-spacing;
    }

    &--icon-position-right #{$this}__icon {
      margin-left: $icon-spacing;
    }

    &--background-color-lightgray {
      background: color(--c-cms-expansion-panel-toggle-background-lightgray);
    }

    &--background-color-white {
      background: color(--c-cms-expansion-panel-toggle-background-white);
    }

    &__inner {
      display: flex;
      align-items: center;
    }

    &__title {
      flex: 1;
    }

    &__icon .e-icon-sprite {
      transform: rotate(-180deg);
      transition: transform var(--duration-regular) ease-in;
      width: 1em;
      height: 1em;
    }
  }
</style>
